import React from 'react';

import StockFilterMultiSelectParts from '@/components/StockFilterMultiSelectParts';
import {
  StockFilterMultiSelectPartsOptionType,
  StockFilterMultiSelectPartsSelectedOptionType,
} from '@/components/StockFilterMultiSelectParts/types';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  deleteCarModels,
  getSelectedCars,
  getStockBrandsAndModels,
  setCarModel,
  setCarModelsAll,
  setPage,
} from '@/store/reducers/cars-stock';
import { getModelsOptionsBySelectedBrands } from '@/modules/CarsStock/components/common.helpers';

function ModelFilter() {
  const dispatch = useTypedDispatch();
  const selectedBrands = useTypedSelector(getSelectedCars).selectedBrands;
  const selectedModels = useTypedSelector(getSelectedCars).selectedModels;
  const stockBrandsAndModels = useTypedSelector(getStockBrandsAndModels);

  const modelsOptions = getModelsOptionsBySelectedBrands(
    stockBrandsAndModels,
    selectedBrands
  );
  const isDisabledModel = selectedBrands && selectedBrands.length === 0;

  const handleChangeModel = (
    model: StockFilterMultiSelectPartsSelectedOptionType
  ) => {
    dispatch(setCarModel(model));
    dispatch(setPage(1));
  };

  const handleChangeModelsAll = (
    models: StockFilterMultiSelectPartsOptionType
  ) => {
    dispatch(setCarModelsAll(models));
    dispatch(setPage(1));
  };

  const handleClearModel = () => {
    dispatch(deleteCarModels());
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelectParts
      label="Модель"
      options={modelsOptions}
      selectedOptions={selectedModels}
      onChange={handleChangeModel}
      onChangeAll={handleChangeModelsAll}
      onClear={handleClearModel}
      disabled={isDisabledModel}
      disabledHint="Сначала выберите марку авто"
    />
  );
}

export default ModelFilter;
